import { combineReducers } from 'redux';
import isLoggedIn from './isLoggedIn';
import domains from './domains';
import accessType from './accessType';

export default combineReducers({
  isLoggedIn,
  domains,
  accessType
});